// extracted by css-extract-rspack-plugin
export default {"popover":"popover-YRz836","card":"card-nZ8iJF","results":"results-OXCrHW"};